import React from 'react';
import { useTranslation } from 'react-i18next';
import EditMaxPractitionersLimit from './EditMaxPractitionersLimit';
import './ClinicSettings.css';

const ClinicSettings = ({ user }) => {
  const { t } = useTranslation();

  return (
    <div className="clinic-settings-container">
      <div className="clinic-settings-header">
        <h1 className="clinic-settings-heading">{t('clinic_settings.title')}</h1>
        <p className="clinic-settings-description">
          {t('clinic_settings.description')}
        </p>
      </div>

      <div className="clinic-settings-body">
        <EditMaxPractitionersLimit user={user} />
      </div>
    </div>
  );
};

export default ClinicSettings;
